import { render, staticRenderFns } from "./JoinOurDiscord.vue?vue&type=template&id=5dcd205e"
import script from "./JoinOurDiscord.vue?vue&type=script&lang=ts"
export * from "./JoinOurDiscord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports